import { memo, useMemo } from "react";
import { getYoutubeEmbedUrl } from "helpers/youtube";
import { MarketplaceDetails } from "services/api/sales/listings/types";
import { ChipToggle } from "ui/modules/sales/pages/listings/components/ListingEditCard/components/MarketplaceStep/primitives";
import { EmptyHint, Section } from "./primitives";

interface Props {
  details?: MarketplaceDetails | null;
}

// Sekcija "Video" — ako je YouTube URL prepoznat, ugnijezdi iframe; u suprotnom
// prikaže običan klikabilan link.
const ListingVideoSection: React.FC<Props> = ({ details }) => {
  const url = details?.youtubeUrl?.trim();
  const embed = useMemo(() => (url ? getYoutubeEmbedUrl(url) : null), [url]);

  // Razgledavanje video pozivom stoji uz video i na unosu, pa se prikazuje u oba slučaja.
  const videoCallChip = (
    <div className="mt-4 mb-3">
      <ChipToggle label="Razgledavanje video pozivom" selected={!!details?.videoCallViewing} readOnly />
    </div>
  );

  if (!url) {
    return (
      <Section title="Video">
        <EmptyHint text="YouTube link videa nije unesen za ovaj oglas." />
        {videoCallChip}
      </Section>
    );
  }

  return (
    <Section title="Video">
      {embed ? (
        <div className="aspect-video w-full max-w-2xl rounded-sm overflow-hidden border border-slate-200">
          <iframe
            src={embed}
            title="YouTube video"
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <a href={url} target="_blank" rel="noreferrer" className="text-sky-600 underline text-sm">
          {url}
        </a>
      )}
      {videoCallChip}
    </Section>
  );
};

export default memo(ListingVideoSection);
